module.exports = __webpack_public_path__ + "static/media/brahem5.f09cbe36.webp";